// extracted by mini-css-extract-plugin
export default {"test":"card_test__IY74X"};